import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function NumberInput({ nbr, className, edit, submit }: Props) {
  return (
    <input
      type="number"
      value={nbr}
      className={classNames(styles.input, className)}
      onChange={({ target }) => edit(parseFloat(target.value))}
      onBlur={() => submit(nbr)}
      onKeyUp={({ key }) => key === "Enter" && submit(nbr)}
    />
  );
}

export { NumberInput };
